<mat-card class="example-card">
    <mat-card-content>
        <span mat-line>{{ 'TERMSCONDITIONS' | translate}}</span>
    </mat-card-content>
    <mat-card-actions align="end">
      <button mat-button (click)="cancel()">{{ 'REFUSE' | translate}}</button>
      <button mat-button (click)="accept()">{{ 'ACCEPT' | translate}}</button>
      <button mat-button (click)="more()">{{ 'MORE' | translate}}</button>
    </mat-card-actions>
</mat-card>